import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-flux-search-import',
    templateUrl: './flux-search-import.component.html',
    styleUrls: ['./flux-search-import.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FluxSearchImportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
